import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { PartnerGeneralInfo } from '../types/PartnerGeneralInfo'
import { isEmpty } from '../../../utils/isEmpty'

const PARTNER_ENDPOINTS: { [key: string]: string } = {
  PUBLISHER: '/partners/publishers',
  VENDOR: '/partners/vendors',
  AFFILIATE: '/partners/affiliates'
}

export const updatePartnerGeneralInfo = async (
  generalInfo: PartnerGeneralInfo
) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { patch } = StackAPI()
  const { id, type } = role

  const request = {
    path: `${PARTNER_ENDPOINTS[type]}/${id}`,
    params: {
      contact_info_attributes: {
        email: generalInfo.primaryContact,
        phone_number: generalInfo.phoneNumber
      }
    }
  }

  return await patch(request)
    .then((response) => {
      if (response.status !== 200) {
        return { error: 'bad response' }
      }

      return response.data
    })
    .catch(() => ({ error: 'unknown error' }))
}
